import { Component, OnInit, ViewEncapsulation, ViewChild, ViewContainerRef, Inject, Output, ChangeDetectorRef, Input, EventEmitter } from '@angular/core';

import { ToastrService } from 'ngx-toastr';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { GlobalComponent } from 'src/app/global/global.component';
import { IMyDpOptions } from 'mydatepicker';
import { DetailRowService, GridComponent, GridModel, IEditCell, SelectionSettingsModel, DataSourceChangedEventArgs, ToolbarItems, EditSettingsModel, parentsUntil, QueryCellInfoEventArgs, CellEditArgs, DataStateChangeEventArgs, ReorderService } from '@syncfusion/ej2-angular-grids';
import { DatePipe } from '@angular/common';
import { sortingObj, TimeSheetVerificationList, LineItemDetail, LineItem, Error, GetTimesheetverificationBO, ClientERRBOTSV, keyvalue, claiminput, ClaimUpdateBO, fp } from '../timesheetverification/timesheetverification.model';

import { Observable, Subject } from 'rxjs';
import { TimesheetVerificationService } from './timesheetverification.service';
import { TextWrapSettingsModel } from '@syncfusion/ej2-grids';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { EditDetailsAuthorization, ClientAuthorizationBO, WhereCondition, EditSOCDetails, editcertificate, ClientCertificationBO, } from '../client-parent/client-parent.model';
import { DateService } from 'src/app/date.service';
import { ColumnChangeBO, columnWidth } from '../list/list.model';
import { takeUntil } from 'rxjs/operators';
import { CommonApiService } from 'src/app/commonapiservice';
import { GeneralService } from 'src/app/service/general.service';
import { IsViewEditpayorequired } from '../employee/employee.model';
@Component({
  selector: 'app-timesheetverification',
  templateUrl: './timesheetverification.component.html',
  styleUrls: ['./timesheetverification.component.scss'],
  providers: [DetailRowService, ReorderService],
  encapsulation: ViewEncapsulation.None,
})
export class TimesheetverificationComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  public sendToBillinProgress: boolean = false;
  public wrapSettings: TextWrapSettingsModel;
  public countryParams: IEditCell;
  public checkparams;
  isclearFilteringorSorting: boolean = false;
  public countryElem: HTMLElement;
  public countryObj: DropDownList;
  public selectionOptions: SelectionSettingsModel
  public statechange: DataSourceChangedEventArgs;
  public toolbar: ToolbarItems[];
  public editSettings: EditSettingsModel;
  public enablepayrate: boolean = false;
  payoRequiredViewEdit: IsViewEditpayorequired = new IsViewEditpayorequired();
  overfixedhours: number = 0;
  TimesheetList: TimeSheetVerificationList[];
  LineItem: LineItem[];
  LineItemDetail: LineItemDetail[];
  disabledNotes: boolean = false;
  Archievenotes: string = "";
  pagshort: sortingObj = new sortingObj();
  wholedata: TimeSheetVerificationList[];
  public parentData: object[] = [];
  public childData: any = [];
  public details: any = [];
  serialno: any;
  updateddata: any = []
  clientIdErr: string;
  Reasonforarchive: string;
  TimesheetVerificationtab = "Active";
  genderList: [{ Key: number, Value: string }];
  Payor: string = "Payor";
  Service: string = "Service";
  payorList: [{ Key: string, Value: string }];
  childTimeSheetId: any = [];
  errorlist: Error[] = [];
  idsList: TimeSheetVerificationList[];
  selectedCheckbox: any = [];
  showerrolist: Error[] = [];
  showerrolistfilter: Error[] = [];
  isEnabled: boolean = false;
  result3: any = [];
  overall: number = 275;
  public selIndex: number[] = [];
  result4: any = [];
  timesheetverificationcolumn: any = []
  ClaimStatusList: any = [];
  Errmsg: string = "";
  billingUnit: any = [];
  Allservice: any = [];
  isColorEditValue: boolean[] = [];
  AuthorizationDetails:any=[];
  clientAuthorizationId: any;
  ErrModalClient: any = [];
  ErrModalGrouppayor: any = [];
  GridType: any = "";
  ErrModalCompany: any = [];
  ErrModalGrouppayorService: any = [];
  ErrModalIcd10: any = [];
  detailstime: object[] = [];
  result2: any = [];
  isNewAuth:boolean=false;
  ParentserialNumber: any = [];
  serviceDate1: any;
  clientId: any;
  timeSheetId: Int32List;
  saveErr: boolean = false;
  selectClaimStatus: any;
  ProgressID: string;
  dailyHours: number;
  lineStatus: string;
  over275Hrs: number;
  overDaily16Hours: number;
  serviceCode: string;
  procedureCode: number;
  timesheetIdservice: number;
  serviceDate: string;
  childserviceDate :string;
  remaimimgAuthorizedHours: string;
  mOD1: string;
  mOD2: string;
  mOD3: string;
  uMPIMissing: string;
  singledata: any = [];
  mulitpledata: TimeSheetVerificationList[];
  Type: any;
  KeyArr: keyvalue[] = [];
  Keyvalue: any = [];
  ClienctBO: ClientERRBOTSV = new ClientERRBOTSV();
  dontshowAuth: boolean = false;
  employees: any;
  selectAllValue: boolean = false;
  selectsingleValue: boolean = false;
  selectedId: any = [1, 2]
  EditICD: boolean = false;
 
  Editcert: boolean = false;
  LinkStatus: any = [];
  EditStartofcare: boolean = false;
  EditSOC: boolean = false;
  EditSOCOptions: EditSOCDetails = new EditSOCDetails();
  authinput: EditDetailsAuthorization = new EditDetailsAuthorization();
  public formatOptions: object;
  public formatPhoneNumber: object;
  TimesheetApproveFilter: string = "All"
  ListSendBO: GetTimesheetverificationBO = new GetTimesheetverificationBO();
  conditionlist: WhereCondition[] = [];
  conditionData: WhereCondition = new WhereCondition();
  type: string = "";
  initialPage: object;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  public dropdata: string[];
  public data: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  public height = '220px';
  serviceName: any = [];
  orderList: any = [];
  date: Date = new Date();
  ListClientFilter: any =null
  ListEmployeeFilter: any = null;
 
  
  StartDate: any = "";
  EndDate: any = "";
  fromdate: string;
  todate: string; @ViewChild('childtemplate') public childtemplate: any;
  @ViewChild('checkboxtemplate') public checkboxtemplate: any;
  @ViewChild('grid') public grid: GridComponent;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    showClearDateBtn: false,
    editableDateField: true,
  };
  public myDatePickerOptionsforFilter: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: false,
    editableDateField: true
  };
  eanbleclient: boolean = true;
  enablestart: boolean = true;
  eanbleend: boolean = true;
  verificationGuid: string = null;
  eanbleservice: boolean = true;
  payorListgroup: any = [];
  I837: any = [];
  GroupPayorlist: any = [];
  isIns: boolean = false;
  authorizationdetails: any = [];
  EditAuthorization: boolean = false;
  public childGrid: GridModel;
  public filterOptions: object;
  public secondChildGrid: any;
  public showCheckBox: boolean = true;
  public country: { [key: string]: Object }[] = [
    { countryName: 'Ready', countryId: '1' },
    { countryName: 'Validate', countryId: '2' }
  ];
  updatedBO: any = [];
  grouplid: number;
  isCheckedBool: boolean = false;
  updatedclaimstatus: any
  stateList: any = []
  columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: number = 0;
  arraycol: any = [];
  isDataAvailableToPrint: boolean = false;
  ColumnArray: columnWidth[]
  @Input() fromClaim: claiminput = new claiminput();
  @Output() outclaim = new EventEmitter<string>();
  updateclaim: boolean = false;
  sendupdateclaimdata: ClaimUpdateBO = new ClaimUpdateBO()
  editEmployee: any = null;
  editemployeeId: any = null;
  editclientId: any = null;
  editgrouppayorId = null;
  editClient: any = null;
  editDate: any = null;
  checkParentclaimStatus: any = null;
  checkchildclaimStatus: any = null;
  edittime: any = null;
  fixedhours: number = 0;
  timesheetnotes: any = null;
  editNotes: any = null;
  timesheetId: any = null;
  EmployeeDropDown: any
  ClientDropDown: any;
  editemp: any;
  editcli: string;
  edithours: string = "";
  editserviceoverall: any = null;
  clientauthId: string;
  groupId: string;
  companyId: string;
  fp: fp = new fp();
  groupServiceId: string;
  ErrModalclientAuth: any = [];
  ErrModalemployee: any = [];
  payrname: string;
  getAlert: string = "";
  sendingdata: TimeSheetVerificationList[];
  startDateauth: any;
  endDateauth: any;
  editserialnumber: number;
  ValidationDate: any;
  public timesheetsToEdit = [];
  TimesheetVerificationDataList: any = [];
  locationLid: any;
  timesheetPaidList: any = [];
  AllEmployeeDropDownListwithStatus: any = [];
  AllClientDropDownListwithStatus: any = [];
  editservice: any = null;
  isSupervisingprovider:boolean=false;
  editSupervisingprovider:boolean=false;
  TimesheetVerificationTotalColumns:number=23;
  ngAfterContentChecked() {
    this.ref.detectChanges();
  }
  ngAfterViewInit() {
    this.childtemplate.elementRef.nativeElement._viewContainerRef = this.viewContainerRef;
    this.childtemplate.elementRef.nativeElement.propName = 'template';
    this.checkboxtemplate.elementRef.nativeElement._viewContainerRef = this.viewContainerRef;
    this.checkboxtemplate.elementRef.nativeElement.propName = 'template';
  }
  constructor(public CommonAPI: CommonApiService, public http: HttpClient, private ref: ChangeDetectorRef, public global: GlobalComponent, public toastrService: ToastrService, public TVService: TimesheetVerificationService,
    public general: GeneralService, public dateservice: DateService, private datePipe: DatePipe, @Inject(ViewContainerRef) private viewContainerRef?: ViewContainerRef,
  ) {
    this.global.agencyList();
    this.data = TVService;
  }
  ngOnInit(): void {
    this.clearGridLocalStorage();
    if (this.global.globalAgencyId == null || this.global.globalAgencyId == '' || this.global.globalAgencyId == undefined || this.global.globalAgencyId == 0 || this.global.globalAgencyId == '00000000-0000-0000-0000-000000000000') {
      return;
    }
    this.FunctionPermission();
    if (this.global.selectedLocationDropdown == null || this.global.selectedLocationDropdown == undefined || this.global.selectedLocationDropdown == '') {
      this.locationLid = null;

    }
    else {
      this.locationLid = this.global.selectedLocationDropdown;
    }
    this.isclearFilteringorSorting = true;
    this.dropdata = ['Ready', 'Validate', 'OverUnits'];
    this.ClaimStatusList = [
      {
        "Key": 'Ready',
        "Value": "Ready"
      },
      {
        "Key": "Validate",
        "Value": "Validate"
      },
      {
        "Key": "OverUnits",
        "Value": "OverUnits"
      }
    ]
    this.wrapSettings = { wrapMode: 'Content' };
    this.toolbar = ['ColumnChooser'];
    this.getService();
    // this.getagency();
    this.getClient();
    this.getAllClient();
    this.getAllEmployeeDropDown();
    this.CommonAPI.getStateJson().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.stateList = data;
    });
    if (this.fromClaim != null && this.fromClaim != undefined) {
      if (this.fromClaim.from == 'Claim') {
        this.updateclaim = true;
        this.fromdate = this.datePipe.transform(this.fromClaim.start, "MM/dd/yyyy")
        this.todate = this.datePipe.transform(this.fromClaim.end, "MM/dd/yyyy")
        this.ListSendBO.Claimid = this.fromClaim.claimId;
        this.ListSendBO.timesheetId = this.fromClaim.ids;
        this.gettimesheetdata();
      }
      else {
        this.dates()
      }
    }
    else {
      this.dates()
    }
    this.filterOptions = {
      type: 'Menu'
    };
    this.updatedBO = [];
    //let val = JSON.parse(this.global.globalColumn.column)
    // let pag = val[0].TimesheetVerification.Pagesize;
    let pag = 10;
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: pag, pageSize: pag, pageSizes: this.pageSizes };
    this.pagshort.itemperpage = pag;
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.editSettings = { allowEditing: false, mode: 'Normal', allowEditOnDblClick: true }
    this.selectionOptions = {
      checkboxOnly: true
    }
    this.checkparams =
    {
      checked: false
    }
    this.countryParams = {
      create: () => {
        this.countryElem = document.createElement('input');
        return this.countryElem;
      },
      read: () => {
        this.updatedclaimstatus = this.countryObj.text;
        return this.countryObj.text;
      },
      destroy: () => {
        this.countryObj.destroy();
      },
      write: () => {
        this.countryObj = new DropDownList({
          dataSource: this.country,
          fields: { value: 'countryId', text: 'countryName' },
          placeholder: 'Claim Status',
          floatLabelType: 'Never'
        });
        this.countryObj.appendTo(this.countryElem);
      }
    };
    this.childGrid = {
      queryCellInfo: this.customiseCell,
      queryString: 'serialNo',
      allowSorting: false,
      allowPaging: false,
      load() {
        this.registeredTemplate = {};
      },
      columns: [
        { headerText: 'Split Day', width: 100, template: this.childtemplate },
        { template: this.checkboxtemplate, headerText: 'Approve', width: 100 },
        { field: 'serviceDate', headerText: 'ServiceDate', width: 130 },
        { field: 'serviceCode', headerText: 'ServiceCode', width: 120 },
        { field: 'dailyHours', headerText: 'Daily Hours', width: 110 },
        { field: 'overDaily16Hours', headerText: 'Over Daily 16 hours', width: 130 },
        { field: 'payDate', headerText: 'Pay Date', width: 110 },
        { field: 'timesheetNotes', headerText: 'Timesheet Notes', width: 110 },
        { field: 'hoursPerDay', headerText: 'HoursPerDay', width: 80, },
        { field: 'hoursPerWeek', headerText: 'HoursPerWeek', width: 80, },
        { field: 'unitsRemaining', headerText: 'RemainingUnits', width: 80, },
        { field: 'remaingHours', headerText: 'RemainingHours', width: 80, },
      ]
    };
    this.timesheetPaidList = [
      {
        Key: true,
        Value: "Yes"
      },
      {
        Key: false,
        Value: "No"
      }
    ]

  }
  ///........................................onLoad....................................................
  onLoad() {
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data.count > 0) {
        this.grid.childGrid.dataSource = this.childData;
      }
    });
    this.grid.childGrid.dataSource = this.childData;
  }
  ///........................................show....................................................
  show() {
    this.grid.columnChooserModule.openColumnChooser(500, -250); // give X and Y axis
  }
  
  ///........................................dataEmitfromChild....................................................
  dataEmitfromChild(event: EditDetailsAuthorization) {
    this.EditAuthorization = false;
    this.authinput.isEdit = false;
   
    if(!this.isNewAuth)
    {
      document.getElementById("OpenModal1").click();
      document.getElementById("OpenModal2").click()
      this.ListSendBO.requesttype = "getdata"
      this.gettimesheetdata();
    }
    else 
    {
      this.authinput.isView = true;
      this.authinput = event;
      this.getAuthorizationDetails()
    }
  }
  ///........................................addClientAuth....................................................
  addClientAuth() {
    this.authinput.ClientId = this.clientIdErr;
    this.authinput.isEdit = true;
    this.authinput.AuthorizationId = this.clientauthId;
    this.authinput.isEditAuthorization = true;
    this.authinput.isView = false;
    this.EditAuthorization = true;
    this.authinput.AuthorizationData.id = this.clientauthId;
    this.authinput.AuthorizationData.payerId = this.groupId;
    this.authinput.AuthorizationData.companyId = this.companyId;
    this.authinput.AuthorizationData.payerServiceMapId = this.groupServiceId;
  }
  ///........................................startdates....................................................
  startdates(startdate, enddate, clientsid) {

    if (startdate == undefined || startdate == "undefined" || startdate == 'undefined') {
      this.eanbleend = true;
      if (new Date(startdate) == undefined) {
        return;
      }
    } else {
      this.eanbleend = false;
    }
    if (enddate == undefined || enddate == "undefined" || enddate == 'undefined') {
      this.eanbleservice = true;
      if (new Date(enddate) == undefined) {
        return;
      }
    } else {
      this.eanbleservice = false;
    }
    startdate = this.datePipe.transform(startdate, 'MM-dd-yyyy');
    enddate = this.datePipe.transform(enddate, 'MM-dd-yyyy');
    if (clientsid == undefined || clientsid == '' || clientsid == "") {
      clientsid = null
    }
    if (startdate != null && enddate != null && clientsid != null) {
      if ((new Date(startdate).getTime() < new Date(enddate).getTime()) || (startdate == enddate)) {
        let parameter = new URLSearchParams();
        parameter.append("startdate", startdate)
        parameter.append("enddate", enddate)
        parameter.append("clientid", clientsid)
        let url = "api/Timesheet/FilteracctoStartdate?";
        this.CommonAPI.GetFunctionwithResponseTypeJson(parameter, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          let i;
          this.serviceName = "";
          this.orderList = [];
          let service = [];
          if (data.length != 0) {
            for (i = 0; i < data.length; i++) {
              service[i] = { value: data[i].masterServiceCode, label: data[i].masterServiceCode, key: data[i].masterServiceId };

              if (data[i].billingunit != 0) {
                let diffDays = Math.round(Math.abs(new Date(data[i].endDate).getTime() - new Date(data[i].startDate).getTime()) / (1000 * 60 * 60 * 24) + 1);
                let units = data[i].totalUnits / diffDays;
                data[i].totalunitperday = units / data[i].billingunit;
                data[i].totalunitperday = data[i].totalunitperday.toString();
                let vals = data[i].totalunitperday.split('.');
                let vals2 = 0 + "." + vals[vals.length - 1];
                if (parseFloat(vals2) < 0.25) {
                  data[i].unithr = vals[0];
                  data[i].unitmin = "0";
                }
                else if (parseFloat(vals2) < 0.50) {
                  data[i].unithr = vals[0];
                  data[i].unitmin = "15";
                }
                else if (parseFloat(vals2) < 0.75) {
                  data[i].unithr = vals[0];
                  data[i].unitmin = "30";
                }
                else if (parseFloat(vals2) < 1) {
                  data[i].unithr = vals[0];
                  data[i].unitmin = "45";
                }
              }
              else {
                data[i].unithr = "0";
                data[i].unitmin = "0";
              }
            }
          }
          this.authorizationdetails = data;
          if (this.authorizationdetails.length == 0) {
            this.dontshowAuth = true;
            this.isIns = false;
          }
          else {
            this.dontshowAuth = false;
            this.isIns = true;
          }
        })
      }
    }
  }
  ///........................................groupchange....................................................
  groupchange(id) {
    if (id == undefined) {
    }
    else {
      this.getpayer(id)
    }
  }
  ///........................................getpayer....................................................
  getpayer(groupId) {
    let url = "api/Payer/getpayerId?";
    let param = new URLSearchParams();
    param.append("groupId", groupId);
    this.CommonAPI.GetFunctionwithResponseTypeJson(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any = []) => {
      this.payorListgroup = data;
    })
  }
  ///........................................getagency....................................................
  getagency() {
    let url = "api/AgencySetting/GetAgencySetting?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("", url).pipe(takeUntil(this.onDestroy$)).subscribe((value: any) => {
      this.overfixedhours = parseInt(value.overallFixedHrs);
      this.fixedhours = parseInt(JSON.parse(JSON.stringify(this.overfixedhours)));
    })
  }
  ///........................................getPayorList....................................................
  getPayorList() {
    let url = "api/Payer/CommonGetGPList?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("", url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.payorList = data;
    },
      err => {

      })
  }
  ///........................................Refresh....................................................
  Refresh() {
    this.ListEmployeeFilter = null;
    this.ListClientFilter = null;
    this.ListSendBO.requesttype = "getdata";
    this.ListSendBO.matchCase = false;
    this.ListSendBO.operator = "startswith";
    this.ListSendBO.value = "";
    this.ListSendBO.type = "string"
    this.ListSendBO.field = "clientName";
    this.selectClaimStatus = null;
    this.ListSendBO.status = null;
    this.ListSendBO.employee = "00000000-0000-0000-0000-000000000000"
    this.ListSendBO.client = "00000000-0000-0000-0000-000000000000"
    this.ListSendBO.currentpageno = 1;
    this.ListSendBO.isPaid = null
    this.pagshort = new sortingObj();
    this.pagshort.shortcolumn = "fromDate"
    this.pagshort.shortType = 'ASC';
    this.parentData = []
    this.childData = []
    this.dates();
    this.grid.clearFiltering();
    this.grid.clearSorting();
    this.ApplyforupdateClaims();
  }
  ///........................................getdata....................................................
  getdata(args) {
    alert("toolbar");
    if (args.data['bit'] > 0) {
      args.row.getElementsByClassName('e-gridchkbox')[0].classList.add('disablecheckbox');
      args.row.getElementsByClassName('e-checkbox-wrapper')[0].classList.add('disablecheckbox')
    }
    var grid = (parentsUntil(args.target, 'e-grid') as any);
    this.result3 = grid.ej2_instances[0].getRowInfo(args.target).rowData;
  }
  ///........................................recordDoubleClick....................................................
  recordDoubleClick(args) {
    var grid = (parentsUntil(args.target, 'e-grid') as any);
    var rowInfo = grid.ej2_instances[0].getRowInfo(args.target);
    if (rowInfo && rowInfo.rowData) {
      this.updateddata = rowInfo.rowData;
      if (this.updateddata && typeof this.updateddata.serialNo !== 'undefined') {
        this.serialno = this.updateddata.serialNo;
      }
    }
  }
  ///........................................updatingrecord....................................................
  updatingrecord(updatedclaimstatus) {
    this.updatedBO = [];
    if (updatedclaimstatus == 'Ready') {
      let serialNo = this.serialno;
      this.TimesheetList.forEach(element => {
        if (element.serialNo == serialNo) {
          element.claimStatus = updatedclaimstatus;
          this.updatedBO.push(element);
        }
      });
      this.gettimesheetdata();
    }
  }
  ///........................................onActionComplete....................................................
  public onActionComplete(args) {
    this.conditionlist = [];
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.grid.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Action" && element.headerText != "Validate" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Action" && element.headerText != "Validate" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {

        this.arraycol[0].TimesheetVerification.ShowColumns.forEach(old => {
          showarr.forEach(element => {
            if (old == element) {
              count1 = count1 + 1;
            }
          });
        });
        this.arraycol[0].TimesheetVerification.HideColumns.forEach(old => {
          hidearr.forEach(element => {
            if (old == element) {
              count = count + 1;
            }
          });
        });
        if (this.arraycol[0].TimesheetVerification.ShowColumns.length != count1 || this.arraycol[0].TimesheetVerification.HideColumns.length != count) {
          this.arraycol[0].TimesheetVerification.ShowColumns = showarr;
          this.arraycol[0].TimesheetVerification.HideColumns = hidearr;
          // this.SaveColumnwidth();
        }
      }
    }
    if (args.requestType == "filterafteropen") {
      this.ListSendBO.type = args.columnType;
    }
  }
  ///........................................dataStateChange....................................................
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    this.pagshort.currentPgNo = this.grid.pagerModule.pagerObj.currentPage;
    this.pagshort.itemperpage = this.grid.pagerModule.pagerObj.pageSize;
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.ListSendBO.orderColumn = state.sorted[0].name;
        this.ListSendBO.orderType = state.sorted[0].direction === 'descending' ? 'desc' : 'asc';
        this.ListSendBO.requesttype = "pageing"
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.ListSendBO.field = state.action.currentFilterObject.field;
      this.ListSendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.ListSendBO.operator = state.action.currentFilterObject.operator;
      this.ListSendBO.value = state.action.currentFilterObject.value;
      this.ListSendBO.requesttype = "pageing"
      if (this.ListSendBO.type == "number") {
        this.ListSendBO.value = state.action.currentFilterObject.value.toString();
        this.ListSendBO.field = state.action.currentFilterObject.field;
      }
      else {
        this.ListSendBO.value = state.action.currentFilterObject.value;
        this.ListSendBO.field = state.action.currentFilterObject.field;
      }
      if (this.ListSendBO.type == "date") {
        this.ListSendBO.value = (new Date(new Date(state.action.currentFilterObject.value).toLocaleDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
        this.ListSendBO.field = state.action.currentFilterObject.field;
      }
      else {
        this.ListSendBO.value = state.action.currentFilterObject.value;
        this.ListSendBO.field = state.action.currentFilterObject.field;
      }
      this.ListSendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.ListSendBO.operator = state.action.currentFilterObject.operator;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.ListSendBO.field = "clientName";
        this.ListSendBO.matchCase = false;
        this.ListSendBO.operator = "startswith";
        this.ListSendBO.value = "";
        this.ListSendBO.requesttype = "pageing"
      }
    }
    if (this.type == "paging" && state.action.name == "actionBegin") {
      this.ListSendBO.requesttype = "pageing"
      // if (this.arraycol[0].TimesheetVerification.Pagesize != state.take) {
      //   this.arraycol[0].TimesheetVerification.Pagesize = state.take
      //   // this.SaveColumnwidth();
      // }
    }
    if (state.action.requestType != "refresh") {
      this.gettimesheetdata();
    }
  }
  ///........................................filterchange....................................................
  filterchange() {
    this.ListSendBO.field = "TimesheetDate";
    this.ListSendBO.matchCase = false;
    this.ListSendBO.operator = "startswith";
    this.ListSendBO.value = this.fromdate;
    this.ListSendBO.type = "string"
    this.ListSendBO.currentpageno = 1;
    this.dates();
  }
  ///........................................updatemodal....................................................
  updatemodal() {
    this.KeyArr = [];
    let iserror:boolean=false;
    if (this.ErrModalCompany.length != 0) {
      this.ErrModalCompany.forEach(element => {
        if (element.columnName.startsWith("Company_")) {
          this.Keyvalue = {
            id: element.companyId,
            key: element.columnName.slice(8),
            value: element.columnName_i,
            type: 'company',
            userId: this.global.userID.toString(),
          }
          this.KeyArr.push(this.Keyvalue);
        }
      });
    }
    else if (this.ErrModalClient != 0) {
      this.Keyvalue = [];
      this.ErrModalClient.forEach(element => {
        if (element.columnName_i != undefined) {
          this.Keyvalue = {
            id: element.clientId,
            key: element.columnName.slice(7),
            value: element.columnName_i,
            type: 'client',
            userId: this.global.userID.toString(),
          }
          this.KeyArr.push(this.Keyvalue);
        }
      });
    }
    else if (this.ErrModalGrouppayor != 0) {
      let i = 0
      this.Keyvalue = [];
      this.ErrModalGrouppayor.forEach(element => {
        if (element.columnName_i != undefined) {
          if ((element.grouppayorId == null || element.grouppayorId == 0 || element.grouppayorId == undefined)
            && (element.companyId == null || element.companyId == 0 || element.companyId == undefined)) {
            if (element.columnName_i != undefined) {
              if (element.columnName.startsWith("Payor_")) {
                this.Keyvalue = {
                  id: element.groupPayorId == null ? "00000000-0000-0000-0000-000000000000" : element.groupPayorId,
                  key: element.columnName.slice(6),
                  value: element.columnName_i,
                  type: 'grouppayorcompany',
                  userId: this.global.userID.toString(),
                }
              }
              if (element.columnName.startsWith("Company_")) {
                this.Keyvalue = {
                  id: element.groupPayorId == null ? "00000000-0000-0000-0000-000000000000" : element.groupPayorId,
                  key: element.columnName.slice(8),
                  value: element.columnName_i,
                  type: 'grouppayorcompany',
                  userId: this.global.userID.toString(),
                }
              }
              else if ((!element.columnName.startsWith("Payor_")) && (!element.columnName.startsWith("Company_"))) {
                this.Keyvalue = {
                  id: element.groupPayorId == null ? "00000000-0000-0000-0000-000000000000" : element.groupPayorId,
                  key: element.columnName,
                  value: element.columnName_i,
                  type: 'grouppayorcompany',
                  userId: this.global.userID.toString(),
                }
              }
            }
            this.KeyArr.push(this.Keyvalue);
          }
          else {
            if (element.columnName_i != undefined) {
              if (element.columnName.startsWith("Payor_")) {
                this.Keyvalue = {
                  id: element.groupPayorId == null ? "00000000-0000-0000-0000-000000000000" : element.groupPayorId,
                  key: element.columnName.slice(6),
                  value: element.columnName_i,
                  type: 'grouppayor',
                  userId: this.global.userID.toString(),
                }
              }
              else {
                this.Keyvalue = {
                  id: element.groupPayorId == null ? "00000000-0000-0000-0000-000000000000" : element.groupPayorId,
                  key: element.columnName,
                  value: element.columnName_i,
                  type: 'grouppayor',
                  userId: this.global.userID.toString(),
                }
              }
            }
            this.KeyArr.push(this.Keyvalue);
          }
        }
        i++;
      });
    }
    else if (this.ErrModalGrouppayorService != 0) {
      if (this.ErrModalGrouppayorService[0].grouppayorServiceId == "00000000-0000-0000-0000-000000000000" || this.ErrModalGrouppayorService[0].grouppayorServiceId == null) {
        this.Keyvalue = {
          id: this.ErrModalGrouppayorService[0].grouppayorServiceId == null || this.ErrModalGrouppayorService[0].grouppayorServiceId == undefined ? "00000000-0000-0000-0000-000000000000" : this.ErrModalGrouppayorService.grouppayorServiceId,
          key: this.Payor,
          value: this.ErrModalGrouppayorService[0].columnName_payor,
          type: 'grouppayorservice',
          userId: this.global.userID.toString(),
        }
        this.KeyArr.push(this.Keyvalue);
        this.Keyvalue = {
          id: this.ErrModalGrouppayorService[0].grouppayorServiceId == null || this.ErrModalGrouppayorService[0].grouppayorServiceId == undefined ? "00000000-0000-0000-0000-000000000000" : this.ErrModalGrouppayorService.grouppayorServiceId,
          key: this.Service,
          value: this.ErrModalGrouppayorService[0].columnName_service,
          type: 'grouppayorservice',
          userId: this.global.userID.toString(),
        }
        this.KeyArr.push(this.Keyvalue);
      }
      this.ErrModalGrouppayorService.forEach(element => {
        if (element.columnName_i != undefined) {
          if (element.columnName == "GroupPayorServiceId") {
            this.Keyvalue = {
              id: element.grouppayorServiceId == null || element.grouppayorServiceId == undefined ? "00000000-0000-0000-0000-000000000000": element.grouppayorServiceId,
              key: element.columnName,
              value: this.grouplid,
              type: 'grouppayorservice',
              userId: this.global.userID.toString(),
            }
          } else {
            this.Keyvalue = {
              id: element.grouppayorServiceId == null || element.grouppayorServiceId == undefined ? "00000000-0000-0000-0000-000000000000" : element.grouppayorServiceId,
              key: element.columnName,
              value: element.columnName_i,
              type: 'grouppayorservice',
              userId: this.global.userID.toString(),
            }
          }
          this.KeyArr.push(this.Keyvalue);
        }
      });
    }
    else if (this.ErrModalIcd10 != 0) {
      this.ErrModalIcd10.forEach(element => {
        if (element.columnName_i != undefined) {
          this.Keyvalue = {
            id: element.clientId,
            key: element.columnName,
            value: element.columnName_i,
            type: 'icd10',
            userId: this.global.userID.toString(),
          }
          this.KeyArr.push(this.Keyvalue);
        }
      });
    }
    else if (this.ErrModalclientAuth.length != 0) {
      this.ErrModalclientAuth.forEach(element => {
        if (element.columnName == "Client_ServiceAgreementNo") {
          this.Keyvalue = {
            id: element.clientauthId,
            key: element.columnName.slice(7),
            value: element.columnName_i,
            type: 'clientauth',
            userId: this.global.userID.toString(),
          }
          this.KeyArr.push(this.Keyvalue);
        }
      });
    }
    else if (this.ErrModalemployee.length != 0) {
      // debugger;
      this.ErrModalemployee.forEach(element => {
        //    debugger;
        if (element.columnName == "Employee_UMPI") {
          this.Keyvalue = {
            id: element.employeeId,
            key: element.columnName.slice(9),
            value: element.columnName_i,
            type: 'employee',
            userId: this.global.userID.toString(),
          }
          this.KeyArr.push(this.Keyvalue);
        }
        if (element.columnName == "Employee_RNNPI") {
          //    debugger;
          this.Keyvalue = {
            id: element.employeeId,
            key: element.columnName.slice(9),
            value: element.columnName_i,
            type: 'employee',
            userId: this.global.userID.toString(),
          }
          this.KeyArr.push(this.Keyvalue);
        }
        if (element.columnName == "Supervising Employee RNNPI") {
          //    debugger;
          this.Keyvalue = {
            id: element.supervisingEmployeeId,
            key: 'RNNPI',
            value: element.columnName_i,
            type: 'employee',
            userId: this.global.userID.toString(),
          }
          if(element.columnName_i != null && element.columnName_i != "" && element.columnName_i !=undefined && element.columnName_i.length !=10){
            this.toastrService.error("Please Enter 10 Digit RNNPI");
            iserror=true;
            setTimeout(() => {
              this.toastrService.clear();
            }, 6000);
          }
          this.KeyArr.push(this.Keyvalue);
        }
        if (element.columnName == "Supervising Employee UMPI") {
          //    debugger;
          this.Keyvalue = {
            id: element.supervisingEmployeeId,
            key: 'UMPI',
            value: element.columnName_i,
            type: 'employee',
            userId: this.global.userID.toString(),
          }
          if(element.columnName_i != null && element.columnName_i != "" && element.columnName_i !=undefined && element.columnName_i.length !=10){
            this.toastrService.error("Please Enter 10 Digit UMPI");
            iserror=true;
            setTimeout(() => {
              this.toastrService.clear();
            }, 6000);
          }
          this.KeyArr.push(this.Keyvalue);
        }
      });
    }
    let url = "api/TimeSheetVerfication/GetTimeSheetVerficationFilterErrUpdate";
    if(!iserror){
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.KeyArr, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
      this.toastrService.success('Updated successfully!');
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
      document.getElementById('OpenModal1').click();
      document.getElementById('OpenModal2').click();
      this.gettimesheetdata();
      iserror=false
    },
      (err: any) => {
        this.Errmsg = err
      });
    }
  }
  ///........................................refreshToGetDropDownValues....................................................
  refreshToGetDropDownValues(ListCode: string) {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("Code", ListCode);
    this.CommonAPI.RefreshDropDownList(ListCode, params, url, "LovDropDown").then((data: any) => {
      if (ListCode == 'GENDER') {
        this.genderList = data?.filter(ele=>ele.lovCode?.toUpperCase()!='OTHERS');
      }
      if (ListCode == 'PAYER') {
        this.GroupPayorlist = data;
        this.GroupPayorlist.forEach(element => {
          element.label = element.lovName;
          element.value = element.id.toString();
        });
      }
      if (ListCode == 'I837PINSURANCETYPE') {
        this.I837 = data;
      }
      if (ListCode == 'BILLING') {
        this.billingUnit = data;
      }
    })
  }
  ///........................................getGender....................................................
  getGender() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "GENDER");
    this.CommonAPI.getDropDownList('GENDER', params, url, "LovDropDown").then((data: any) => {
      this.genderList = data?.filter(ele=>ele.lovCode?.toUpperCase()!='OTHERS');
    })
  }
  ///........................................getBillingStatus....................................................
  getBillingStatus() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "PAYER");
    this.CommonAPI.getDropDownList('PAYER', params, url, "LovDropDown").then((data: any) => {
      this.GroupPayorlist = data;
      this.GroupPayorlist.forEach(element => {
        element.label = element.lovName;
        element.value = element.id.toString();
      });
    });
  }
  ///........................................getAuth....................................................
  getAuth() {
    let params = new URLSearchParams();
    params.append("Id", this.clientauthId.toString());
    let url = "api/ClientAuthorization/Getauth?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: ClientAuthorizationBO) => {
      data[0].startDate = this.datePipe.transform(data[0].startDate, 'MM-dd-yyyy');
      data[0].endDate = this.datePipe.transform(data[0].endDate, 'MM-dd-yyyy');
      this.authinput.AuthorizationData.startDate = data[0].startDate;
      this.authinput.AuthorizationData.endDate = data[0].endDate;
      this.authinput.AuthorizationData.insuranceNo = data[0].insuranceNo;
      this.authinput.AuthorizationData.totalUnits = data[0].totalUnits;
      this.authinput.AuthorizationData.unitsRemaining = data[0].unitsRemaining;
      this.addClientAuth();
    });
  }

  

  
EditCertificateoption: editcertificate = new editcertificate();
  ///........................................errmodal....................................................
  errmodal(name) {

    console.log(name,"name=============");
    
    if (name == "Incomplete EVV Found" || name == "Evv Overlapped" || name == "Expired_Authorization" ) {
      return;
    }
    if(name !="ReferringProvider_FirstName" && name !="ReferringProvider_LastName"  &&  name !="ReferringProvider_Identifier" && name!='CertificateICD10_01' 
      && name != 'Icd10' && name != 'StartOfCare')
      { 
       document.getElementById("OpenModal1").click();
      }
    this.ErrModalCompany = [];
    this.ErrModalClient = [];
    this.ErrModalGrouppayor = [];
    this.ErrModalGrouppayorService = [];
    this.ErrModalIcd10 = [];
    this.ErrModalclientAuth = [];
    this.ErrModalemployee = [];


    if (name.startsWith("Client_")) {
      this.getGender();
      if (name == "Client_ServiceAgreementNo") {
        this.showerrolist.forEach(element => {
          this.clientIdErr = element.clientId.toString();
          this.clientauthId = element.clientauthId;
          this.groupId = element.groupPayorId;
          this.companyId = element.companyId;
          this.groupServiceId = element.grouppayorServiceId;
        });

        if (this.clientauthId != null) {
          this.showerrolist.forEach(element => {
            this.clientIdErr = element.clientId.toString();

            document.getElementById('authedit').click();
            if (element.isValid == false && element.columnName == "Client_ServiceAgreementNo") {

              this.ErrModalclientAuth.push(element);
            }
          });

        }
        else {
          this.authinput.type = "new";
          this.addClientAuth();
          this.EditAuthorization = true;
        }
        this.ErrModalClient = [];
      }
      else {
        this.showerrolist.forEach(element => {
          this.clientIdErr = element.clientId.toString();
          if (element.isValid == false && element.columnName.startsWith("Client_") && element.columnName != "Client_ServiceAgreementNo") {
            this.ErrModalClient.push(element);
          }
        });
      }


    }
    else if (name.startsWith("Company") && name != "CompanyIdentifier_NPI" && name != "CompanyIdentifier_CompanyName") {
      this.getI837();
      this.getPayorList();
      this.getBillingStatus();
      this.showerrolist.forEach(element => {
        if ((element.groupPayorId == null || element.groupPayorId == undefined) && (element.companyId == null || element.companyId == undefined)) {


          if (element.isValid == false && ((element.columnName.startsWith("Payor") || element.columnName == "GroupPayorId" || element.columnName == "BillingpayorID"
            || element.columnName == "I837PInsTypeLid" || element.columnName == "Claim_Filling_Ind" || element.columnName == "GroupPayorCompany_ProviderNo"
            || element.columnName == "GroupPayorCompany_CompanyFEIN") || element.columnName.startsWith("Company")) && element.columnName != "CompanyIdentifier_NPI" && element.columnName != "CompanyIdentifier_CompanyName") {
            this.ErrModalGrouppayor.push(element);
          }
        }

        else
          if (element.isValid == false && element.columnName.startsWith("Company")) {
            this.groupId = element.groupPayorId;
            this.companyId = element.companyId;
            this.payrname = element.payorName;


            // this.saveErr = (element.groupPayorId != null || element.groupPayorId != undefined|| element.groupPayorId !=0)? "":"hgfhg";
            if (this.groupId != null && element.columnName.startsWith("Company")) {
              this.saveErr = true;
            }
            this.ErrModalCompany.push(element);

          }
      });
    }
    else if (name.startsWith("Payor") || name == "GroupPayorId" || name == "Group" || name == "BillingpayorID"
      || name == "I837PInsTypeLid" || name == "Claim_Filling_Ind" || name == "GroupPayorCompany_ProviderNo" || name == "DefaultBillType"
      || name == "GroupPayorCompany_CompanyFEIN" || name == "DefaultBillType" || name.startsWith("Company") && name != "CompanyIdentifier_NPI" && name != "CompanyIdentifier_CompanyName") {
      this.getI837();
      this.getPayorList();
      this.getBillingStatus();
      this.showerrolist.forEach(element => {
        if ((element.groupPayorId == null || element.groupPayorId == undefined) && (element.companyId == null || element.companyId == undefined)) {

          if (element.isValid == false && ((element.columnName.startsWith("Payor") || element.columnName == "GroupPayorId" || element.columnName == "Group" || element.columnName == "BillingpayorID"
            || element.columnName == "I837PInsTypeLid" || element.columnName == "Claim_Filling_Ind" || element.columnName == "GroupPayorCompany_ProviderNo"
            || element.columnName == "GroupPayorCompany_CompanyFEIN" || element.columnName == "DefaultBillType") || element.columnName.startsWith("Company")) && element.columnName != "CompanyIdentifier_NPI" && element.columnName != "CompanyIdentifier_CompanyName") {
            this.ErrModalGrouppayor.push(element);
          }
        }
        else {
          if (element.isValid == false && ((element.columnName.startsWith("Payor") || element.columnName == "GroupPayorId" || element.columnName == "Group" || element.columnName == "BillingpayorID"
            || element.columnName == "I837PInsTypeLid" || element.columnName == "DefaultBillType" || element.columnName == "Claim_Filling_Ind" || element.columnName == "GroupPayorCompany_ProviderNo"
            || element.columnName == "GroupPayorCompany_CompanyFEIN"))) {
            this.groupId = element.groupPayorId;
            this.companyId = element.companyId;
            this.payrname = element.payorName;
            if (this.groupId != null && (element.columnName == "GroupPayorCompany_CompanyFEIN" || element.columnName == "Claim_Filling_Ind" || element.columnName == "GroupPayorCompany_ProviderNo")) {
              this.saveErr = true;
            }
            this.ErrModalGrouppayor.push(element);
          }
        }

      });
    }
    else if (name == "Employee_UMPI") { 
      this.showerrolist.forEach(element => {
        if (element.isValid == false && element.columnName == "Employee_UMPI") {
          this.ErrModalemployee.push(element);
        }
      });
    }
    else if (name == "Employee_RNNPI") {
      this.showerrolist.forEach(element => {
        if (element.isValid == false && element.columnName == "Employee_RNNPI") {
          this.ErrModalemployee.push(element);
        }
      });
    }
    else if (name == "SupervisingProvider_Identifier") {
      this.showerrolist.forEach(element => {
        if (element.columnName == "SupervisingProvider_Identifier") {             
        let listofError=[{
        clientId:element.clientId,
        clientauthId:element.clientauthId,
        clientcertificationId:element.certificateId,
        color:element.color,
        colr:element.colr,
        columnName:"Supervising Employee UMPI",
        companyId:element.companyId,
        employeeId:element.employeeId,
        groupPayorId:element.groupPayorId,
        grouppayorServiceId:element.grouppayorServiceId,
        isValid:element.isValid,
        payorName:element.payorName,
        serialno:element.serialno,
        status:element.status,
        supervisingEmployeeId:element.supervisingEmployeeId
      },
      {
        clientId:element.clientId,
        clientauthId:element.clientauthId,
        clientcertificationId:element.certificateId,
        color:element.color,
        colr:element.colr,
        columnName:"Supervising Employee RNNPI",
        companyId:element.companyId,
        employeeId:element.employeeId,
        groupPayorId:element.groupPayorId,
        grouppayorServiceId:element.grouppayorServiceId,
        isValid:element.isValid,
        payorName:element.payorName,
        serialno:element.serialno,
        status:element.status,
        supervisingEmployeeId:element.supervisingEmployeeId
      }];
      this.ErrModalemployee = listofError;    
    }
      });   
    }
    
    else if (name == "EmployeePayorUMPI") {
      this.showerrolist.forEach(element => {
        if (element.isValid == false && element.columnName == "EmployeePayorUMPI") {
          this.payoRequiredViewEdit.isEdit = true;
          this.payoRequiredViewEdit.isView = false;
          this.payoRequiredViewEdit.employeeId = element.employeeId
          this.payoRequiredViewEdit.payorRequiredId = "";
          this.payoRequiredViewEdit.payorRequired = [];
          this.payoRequiredViewEdit.payorActiotype = "new"
          this.enablepayrate = true;
          // debugger;
        }
      })
    }
    else if (name == "GroupPayorServiceId" || name == "Unitrate"
      || name == "BillingUnit" || name == "NetRate" || name == "ServiceLoc" || name == "RevCode") {
      this.getBillingStatus();
      this.getBillingUnit();
      this.getService();
      this.showerrolist.forEach(element => {
        if (element.isValid == false && ((element.columnName == "GroupPayorServiceId" || element.columnName == "Unitrate"
          || element.columnName == "BillingUnit" || element.columnName == "NetRate" || element.columnName == "ServiceLoc"
          || element.columnName == "RevCode"))) {
          this.ErrModalGrouppayorService.push(element);
        }
      });
    }
    else if (name == "Icd10" || name == "CertificateICD10_01" || name == "Physician_NPI" || name == "FirstDigitFacilityLid" || name == "SecondDigitFacilityLid" || name == "FrequncyCodeLid" || name == "PriorityTypeOfAdmissionLid" || name == "PointOfOriginForAdmissionOrVisitLid"
      || name == "PatientDischargeStatusLid" || name =="ReferringProvider_FirstName" || name =="ReferringProvider_LastName"  || name =="ReferringProvider_Identifier") {
console.log("certificate");

      this.EditICD = true;
      let certificateId = "00000000-0000-0000-0000-000000000000";
      this.showerrolist.forEach(element => {
        if (element.isValid == false && ((element.columnName == "Icd10") || (element.columnName == "CertificateICD10_01")
          || (element.columnName == "Physician_NPI") || (element.columnName == "FirstDigitFacilityLid") || (element.columnName == "SecondDigitFacilityLid")
          || (element.columnName == "FrequncyCodeLid") || (element.columnName == "PriorityTypeOfAdmissionLid") || (element.columnName == "PointOfOriginForAdmissionOrVisitLid")
          || (element.columnName == "PatientDischargeStatusLid")
           || (element.columnName =="ReferringProvider_FirstName") 
          || (element.columnName =="ReferringProvider_LastName")||(element.columnName =="ReferringProvider_Identifier")
        )) {
          this.clientIdErr = element.clientId.toString();
           certificateId = element.certificateId ;
          (element.columnName == "ReferringProvider_Identifier"? "referringProvider_NPI":element.columnName );
          this.ErrModalIcd10.push(element);     
          console.log(certificateId ,"Id====");
               
        }
      });

      if (certificateId != "00000000-0000-0000-0000-000000000000" && certificateId != null && certificateId != undefined) {     
        let appenddata = new URLSearchParams();
        appenddata.append("id", certificateId.toString())
        let url = "api/Certification/getSiglecertificateData?"
        this.CommonAPI.GetFunctionwithResponseTypeJson(appenddata, url).pipe(takeUntil(this.onDestroy$)).subscribe((datas: ClientCertificationBO) => {
          this.EditCertificateoption.clientId = parseInt(this.clientIdErr);
          this.EditCertificateoption.type = 'edit';
          this.EditCertificateoption.clientcertifcateData = datas;
          this.Editcert = true;
        })
      }
      else {
        this.EditCertificateoption.clientId = this.clientIdErr;
        this.EditCertificateoption.type = 'new';
        this.Editcert = true;
      }
    }
    else if (name == "StartOfCare") {
      this.EditStartofcare = true;
      this.showerrolist.forEach(element => {
        if (element.isValid == false && (element.columnName == "StartOfCare")) {
          this.clientIdErr = element.clientId.toString();
        }
      });
      this.global.clientId = this.clientIdErr;
      this.EditSOCOptions.type = 'new';
      this.EditSOC = true;
    }
    else if (name == "G2id" || name == "CompanyIdentifier_NPI" || name == "CompanyIdentifier_CompanyName") {
      this.showerrolist.forEach(element => {
        if (element.isValid == false && (element.columnName == "G2id" || element.columnName == "CompanyIdentifier_NPI"
          || element.columnName == "CompanyIdentifier_CompanyName")) {
          this.ErrModalGrouppayorService.push(element);
        }
      });
    }
    else if(name= "SupervisingProvider_Map"){
      this.isSupervisingprovider=true
      this.showerrolist.forEach(element => {
        if (element.isValid == false && (element.columnName == "SupervisingProvider_Map")) {
          this.editSupervisingprovider=true;
          
        }
      });
      document.getElementById("Supervisingopen").click();
    }
  }

  ///........................................getBillingUnit....................................................
  getBillingUnit() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "BILLING");
    this.CommonAPI.getDropDownList('BILLING', params, url, "LovDropDown").then((data: any) => {
      this.billingUnit = data;
    },
      err => {
      });
  }
  ///........................................getService....................................................
  getService() {
    let url = "api/Service/getCommonServicedropdown?";
    this.CommonAPI.GetFunctionwithResponseTypeJson("", url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.Allservice = data;
      this.Allservice.forEach(element => {
        element.Value = element.masterservice.toString();
        element.Key = element.id.toString();
      });
    });
  }
  ///........................................ApplyforupdateClaims....................................................
  ApplyforupdateClaims() {
    if (this.fromClaim.from == 'Claim') {
      this.fromClaim.errorValidation = false;
    }
  }
  ///........................................checkBeforeApply....................................................
  checkBeforeApply() {
    
    this.isclearFilteringorSorting = false;
    let tomorrow = new Date(new Date(new Date().setHours(0, 0, 0, 0)).setDate(new Date().getDate() + 1));
    if (isNaN(new Date(this.fromdate).getTime()) || isNaN(new Date(this.todate).getTime())) {
      this.toastrService.error('Choose a valid From and To Date');
      return;
    }
    if (new Date(this.fromdate).getTime() >= tomorrow.getTime() || new Date(this.todate).getTime() >= tomorrow.getTime()) {
      this.toastrService.error('From and To Date can not be a Future Date');
      return;
    }
    else if (new Date(this.fromdate).getTime() > new Date(this.todate).getTime()) {
      this.toastrService.error('From Date can not be greater than To Date');
      return;
    }
    else {
      this.gettimesheetdata();
    }
  }
  ///........................................checkClaimFilter....................................................
  checkClaimFilter() {
   
    this.checkBeforeApply();

  }
  ///........................................gettimesheetdata....................................................
  gettimesheetdata() {
    if (this.global.checkclaimProgress == true) {
      this.toastrService.error("Billing is inProgress!");
      return;
    }

    if (this.selectClaimStatus != null && this.selectClaimStatus != undefined && this.selectClaimStatus != '') {
      this.ListSendBO.status = this.selectClaimStatus;
    }
    else {
      this.ListSendBO.status = null;
    }
    this.errorlist = [];
    this.parentData = [];
    this.childData = [];
    this.details = []; this.singledata = []
    this.result4 = []
    this.result3 = []
    this.TimesheetList = []
    this.LinkStatus = []
    this.childTimeSheetId = []
    this.childData = []
    this.ParentserialNumber = []
    this.mulitpledata = []
    this.idsList = []
    this.updateddata = []
    if (this.TimesheetVerificationtab == "Active") {
      this.ListSendBO.timesheetType = "active"

    }
    else {
      this.ListSendBO.timesheetType = "archive"
    }
    if (this.TimesheetApproveFilter == "All") {
      this.ListSendBO.isEvvApproved = null;
    }
    else if (this.TimesheetApproveFilter == "Approve") {
      this.ListSendBO.isEvvApproved = true;
    }
    else {
      this.ListSendBO.isEvvApproved = false;
    }
    this.ListSendBO.verificationGuid = this.verificationGuid;
    this.ListSendBO.fromDate = this.global.getDateTimeString(this.fromdate);
    this.ListSendBO.toDate = this.global.getDateTimeString(this.todate);
    this.ListSendBO.pageitem = parseInt(this.pagshort.itemperpage.toString());
    this.ListSendBO.currentpageno = this.pagshort.currentPgNo;
    if (this.global.globalLocationId != null && this.global.globalLocationId != ''
      && this.global.globalLocationId != undefined) {
      this.ListSendBO.locationLid =this.global.globalLocationId;
    }
    else {
      this.ListSendBO.locationLid = "00000000-0000-0000-0000-000000000000";
    }
    this.ListSendBO.employee = (this.ListEmployeeFilter != null )? this.ListEmployeeFilter.toString() : "00000000-0000-0000-0000-000000000000";
    this.ListSendBO.client = this.ListClientFilter != null ? this.ListClientFilter : "00000000-0000-0000-0000-000000000000";
    
    
    this.TVService.outputValues(this.ListSendBO)
    let count = 0;
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.verificationGuid = data.verificationGuid;
      this.verificationGuid
      this.TimesheetVerificationDataList = data.result;
      data?.result?.forEach(element => {
        if (this.fromClaim.from == 'Claim') {
          if (this.editserialnumber == element.serialNo) {
            this.checkParentclaimStatus = element.claimStatus;
            if (this.checkParentclaimStatus != "Validate") {
              this.fromClaim.errorValidation = true;
            }
            else {
              this.fromClaim.errorValidation = false;
            }
          }
        }
      });
      this.childTimeSheetId = [];
      if (data != null && data.result.length > 0) {
        this.isDataAvailableToPrint = true;
      }
      else {
        this.isDataAvailableToPrint = false;
      }
      count = count + 1;
      if (data != null && data != undefined && count == 1) {
        // this.getColumnwidth();

        if (data.result.length > 10) {
          this.grid.height = '500';
        }
        else {

          this.grid.height = 'auto';
        }
      }
      this.selectedId = [];
      this.parentData = data.result;
      this.TimesheetList = this.TVService.getwholeData();
      this.serialno = this.TVService.getserialNo();
      this.childData = this.TVService.getChildData();
      this.details = this.TVService.getDetails();
      this.errorlist = this.TVService.getErrorlist();
      this.idsList = this.TVService.getidsList();
      if (this.selectAllValue) {
        this.TimesheetList.forEach((element, index) => {

          if (element.claimStatus == 'Ready') {
            this.selectedId.push(index);

          }

        });

        setTimeout(() => {
          this.grid.selectionModule.selectRows(this.selectedId);
        }, 1000);
        this.mulitpledata = this.idsList;
      }
      if (this.selectsingleValue) {
        this.singledata.forEach(sel => {
          this.TimesheetList.forEach((element, index) => {

            if (sel.timesheetId == element.timesheetId)
              this.selectedId.push(index);
          });
        });


        this.grid.selectRows(this.selectedId);

      }
      this.childData.forEach((element) => {
        element.overhours = this.fixedhours;
      })
      this.wholedata = data.result;
      this.childGrid = {
        rowDataBound: this.rowDataBound1,
        dataSource: this.childData,
        queryCellInfo: this.customiseCell,
        queryString: 'serialNo',
        allowSorting: false,
        allowPaging: false,
        load() {
          // this.onLoad
          this.registeredTemplate = {};


        },
        editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false },
        columns: [
          { headerText: 'Split Day', width: 100, template: this.childtemplate },
          { template: this.checkboxtemplate, headerText: 'Approve', width: 100 },
          { field: 'errorNotes', headerText: 'Error Notes', width: 130 },
          { field: 'serviceDate', headerText: 'ServiceDate', width: 130 },
          { field: 'serviceCode', headerText: 'ServiceCode', width: 120 },
          { field: 'dailyHours', headerText: 'Daily Hours', width: 120 },
          // { field: 'over275Hrs', headerText: 'Over' + this.fixedhours.toString() + 'Hrs', width: 100 },
          { field: 'overDaily16Hours', headerText: 'Over Daily 16 hours', width: 130 },
          { field: 'payDate', headerText: 'Pay Date', width: 110 },
          { field: 'timesheetNotes', headerText: 'Timesheet Notes', width: 110 },
          // { field: '', headerText: '', width: 80, },
          // { field: '', headerText: '', width: 80, },
          // { field: '', headerText: '', width: 80, },
          // { field: '', headerText: '', width: 80, },
          // { field: 'hoursPerDayHrMin', headerText: 'HoursPerDay', width: 80, },
          // { field: 'hoursPerWeekHrMin', headerText: 'HoursPerWeek', width: 80, },
          // { field: 'unitsRemainingHrMin', headerText: 'RemainingUnits', width: 80, },
          // { field: 'remaingHoursHrMin', headerText: 'RemainingHours', width: 80, },
         // { field: 'isPaid', headerText: 'Paid Payroll', width: 80, },

          // { field: 'uMPIMissingstatus', headerText: 'UMPI Effective or missing', width: 135 },

        ]
      };
      this.grid.childGrid.columns = [
        { headerText: 'Split Day', width: 100, template: this.childtemplate },
        { template: this.checkboxtemplate, headerText: 'Approve', width: 100 },
        { field: 'serviceDate', headerText: 'ServiceDate', width: 130 },
        { field: 'serviceCode', headerText: 'ServiceCode', width: 120 },
        { field: 'dailyHours', headerText: 'Daily Hours', width: 120 },

        // { field: 'over275Hrs', headerText: 'Over' + this.fixedhours.toString() + 'Hrs', width: 100 },

        { field: 'overDaily16Hours', headerText: 'Over Daily 16 hours', width: 130 },
        { field: 'payDate', headerText: 'Pay Date', width: 110 },
        { field: 'timesheetNotes', headerText: 'Timesheet Notes', width: 110 },
      //  { field: 'isPaid', headerText: 'Paid Payroll', width: 80, },
        // { field: '', headerText: '', width: 80, },
        // { field: '', headerText: '', width: 80, },
        // { field: '', headerText: '', width: 80, },
        // { field: '', headerText: '', width: 80, },
        // { field: 'hoursPerDayHrMin', headerText: 'HoursPerDay', width: 80, },
        // { field: 'hoursPerWeekHrMin', headerText: 'HoursPerWeek', width: 80, },
        // { field: 'unitsRemainingHrMin', headerText: 'RemainingUnits', width: 80, },
        // { field: 'remaingHoursHrMin', headerText: 'RemainingHours', width: 80, },
      ];
    })
  }
  ///........................................splitup....................................................
  splitup(args: any) {

    this.detailstime = [];
    var grid = (parentsUntil(args.target, 'e-grid') as any);

    this.result2 = grid.ej2_instances[0].getRowInfo(args.target).rowData;


    this.timeSheetId = this.result2.timeSheetId;



    this.details.forEach(element => {

      if (element.timeSheetId == this.timeSheetId) {
        this.detailstime.push(element)
      }


    });


    // document.getElementById('split').click();
    // this.dialogService.open(splitday);
  }
  ///........................................Edittimesheets....................................................
  Edittimesheets(list) {


    this.lineStatus = list.lineStatus;
    this.dailyHours = list.dailyHours;
    this.uMPIMissing = list.uMPIMissing
    this.remaimimgAuthorizedHours = list.remaimimgAuthorizedHours;
    this.overDaily16Hours = list.overDaily16Hours
    this.mOD1 = list.moD1;
    this.mOD2 = list.moD2
    this.mOD3 = list.moD3;
    this.serviceCode = list.serviceCode;
    this.serviceDate = list.serviceDate
    this.procedureCode = list.serviceId
    this.over275Hrs = list.over275Hrs
    this.timesheetIdservice = list.timeSheetId
    this.serviceDate = list.serviceDate;

   
    // this.dialogService.open(Edittimesheet);
  }
  ///........................................newdates....................................................
  newdates(event, type, value) {
    if (type == "inputchage") {
      if (value == 'start') {

        let val = this.dateservice.inputFeildchange(event);

        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.fromdate = val1;

        }
      }
      if (value == 'end') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.todate = val1;

        }
      }
      if (value == 'serviceDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.serviceDate = val1;

        }
      }
      if (value == 'editdate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.editDate = val1;
        }
      }
    }
    if (type == "datechagned") {
      if (value == 'start') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.fromdate = val1;
          if (this.fromClaim.from != 'Claim') {
            var StartDate = new Date(this.fromdate);
            let setDate = StartDate.setDate(StartDate.getDate() + 365);
            let getDate = setDate;
            this.ValidationDate = this.datePipe.transform(getDate, "MM/dd/yyyy");
            this.clearEndTimeValidation()
          }

        }

      }
      if (value == 'end') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.todate = val1;
          if (this.fromClaim.from != 'Claim') {
            this.clearEndTimeValidation()
          }

        }

      }
      if (value == 'serviceDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.serviceDate = val1;
        }
      }
      if (value == 'editdate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.editDate = val1;
          this.clientAuthorizationId = null;
          this.getAuthorizationDetails();
        }
      }
    }

 
  }
  ///........................................clearEndTimeValidation....................................................
  clearEndTimeValidation() {

    if (this.fromdate != null && this.fromdate != undefined && this.fromdate != ''
      && this.todate != null && this.todate != undefined && this.todate != '') {


      let EndDate = this.datePipe.transform(this.todate, "MM/dd/yyyy");

      if (new Date(EndDate).getTime() > new Date(this.ValidationDate).getTime()) {
        this.toastrService.error("Date range should not be greater than 1 year");
        this.todate = null;

        setTimeout(() => {
          this.toastrService.clear();
        }, 3000);

      }
      if (this.todate != null && this.todate != undefined && this.todate != '') {
        if (new Date(this.fromdate).getTime() > new Date(this.todate).getTime()) {
          this.todate = null;
          this.toastrService.error("end time should greater than start time");
          setTimeout(() => {
            this.toastrService.clear();
          }, 3000);
          return;
        }
      }
    }
  }
  ///........................................save....................................................
  save() {


    let val = {
      serviceId: +this.procedureCode,
      id: this.timesheetIdservice,
      serviceDate: (new Date(new Date(this.serviceDate).toDateString() + " " + "00:00:000" + " " + "GMT").toISOString()).replace("Z", ""),
    }
    let url = "api/Timesheet/updateTimesheetService"
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(val, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      document.getElementById('OpenModal4').click();
      document.getElementById('OpenModal3').click();
      this.toastrService.success('Record updated successfully!');
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
      this.gettimesheetdata();
    },
      (Err: any) => {
        this.toastrService.error(Err, 'Error');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      });

  }
  ///........................................selecttobill....................................................
  selecttobill() {
    this.global.checkidle = true;
    this.global.checkclaimProgress = null;
    this.sendToBillinProgress = true;

    if (this.Type == 1) {
      this.sendingdata = this.mulitpledata;
    }
    else if (this.Type == 2) {

      this.sendingdata = this.singledata;

    }

    this.sendingdata?.forEach(element => {


      element.fromDate = this.global.getDateTimeString(element.fromDate);
      element.toDate = this.global.getDateTimeString(element.toDate);
      element.billingLovLid = element.billingLovLid?.toString();
    });

    if (this.sendingdata == null || this.sendingdata.length == 0) {
      this.toastrService.error('No Record Selected for Send to bill !!!');
      this.sendToBillinProgress = false;
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
    }
    else if (this.sendingdata.length != 0) {
      let url = "api/BillingClaim/SaveBillingClaim";
      this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.sendingdata, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.toastrService.success('Selected Record submited successfully!');
        this.grid.dataSource = [];
        this.sendToBillinProgress = false;
        this.sendingdata = [];
        this.singledata = [];
        this.mulitpledata = [];
        this.ListSendBO.requesttype = "getdata";
        this.ProgressID = data.progressId;
        localStorage.setItem("ac_progressId", this.ProgressID);
        if (data.progressId != null) {
          this.global.scheduleClaimProgress();
        }
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);

      }, (err: any) => {
        this.toastrService.error(err);
        this.sendToBillinProgress = false;
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        this.ListSendBO.requesttype = "getdata";
        this.checkBeforeApply()
        // this.gettimesheetdata();
      }
      );
    }
  }
  ///........................................getI837....................................................
  getI837() {
    let url = "api/LOV/getLovDropDown?"
    let params = new URLSearchParams();
    params.append("ListCode", "I837PINSURANCETYPE");
    this.CommonAPI.getDropDownList('I837', params, url, "LovDropDown").then((data: any) => {
      this.I837 = data;
      this.I837.forEach(element => {
        element.label = element.lovName;
        element.value = element.id.toString();
      });
    },
      );
  }
  // .............................................dates...............................
  dates() {
    var d = this.date.getDate();
    var m = this.date.getMonth() + 1; //Jan is 0
    var yyyy = this.date.getFullYear();
    this.fromdate = m + '/' + d + '/' + yyyy;
    this.todate = m + '/' + d + '/' + yyyy;


    if (this.fromClaim.from != 'Claim') {
      var StartDate = new Date(this.fromdate);
      let setDate = StartDate.setDate(StartDate.getDate() + 365);
      let getDate = setDate;
      this.ValidationDate = this.datePipe.transform(getDate, "MM/dd/yyyy");
    }
    this.gettimesheetdata();

  }
  ///........................................rowDataBound1....................................................
  rowDataBound1(args) {
    if (args.data['bit'] > 0) {
      args.row.style.color = 'White';
      // args.row.style.background = '#EC7063';
    }
  }
  ///........................................datavaluechange....................................................
  datavaluechange(value): any {
    return value;
  }
  ///........................................customiseCell....................................................
  customiseCell(args: QueryCellInfoEventArgs) {

    if (args.column.field === 'over275Hrs') {
      if (args.data[args.column.field] > args.data['overhours']) {

        args.cell.classList.add('warning');
      }
    }
    if (args.column.field === 'overDaily16Hours') {
      if (args.data[args.column.field] > 16) {
        args.cell.classList.add('warning');
      }
    }
    if (args.column.field === 'remaimimgAuthorizedHours') {
      if (args.data[args.column.field] == 0) {
        args.cell.classList.add('warning');

      }

    }
    if (args.column.field === 'serviceDate' && args.data['isCertified'] === false) {
      args.cell.classList.add('warningdate');

    }
  }
  ///........................................cellEdit....................................................
  cellEdit(args: CellEditArgs) {
    if (args.value === 'Ready') {
      args.cancel = true;
    }
  }
  ///........................................validatebutton....................................................
  validatebutton(args: QueryCellInfoEventArgs) {
    if (args.column.field == "validate") {
      if (args.data['buttoncolor'] == "Red") {

        args.cell.firstElementChild.firstElementChild.classList.add('invalid')

      }
      if (args.data['buttoncolor'] == "Green") {
        args.cell.firstElementChild.firstElementChild.innerHTML = "Ready"
        args.cell.firstElementChild.firstElementChild.classList.add('valid')
      }
      if (args.data['buttoncolor'] == "Yellow") {
        args.cell.firstElementChild.firstElementChild.innerHTML = "Over Units"
        args.cell.firstElementChild.firstElementChild.classList.add('overUnits')
      }
    }
  }
  ///........................................dataSourceChanged....................................................
  public dataSourceChanged(state: DataSourceChangedEventArgs): void {
    if (state.action === 'edit') {

      state.endEdit();
    }
  }
  ///........................................SelectErrorData....................................................
  SelectErrorData() {

    this.global.loading = false;
    if (this.isEnabled == true) {
      this.showerrolist = this.showerrolistfilter.filter(err => err.isValid == false);
    }
    else {
      this.showerrolist = this.showerrolistfilter;
    }
  }
  ///........................................show1....................................................
  show1(args: any): void {
    this.mulitpledata = []
    var customselect = [];
    this.singledata=[];
    if (args.checked && args.target.classList.contains('e-checkselectall')) {
      //   if (this.selIndex.length) {
      //     this.grid.selectRows(this.selIndex);
      //     this.selIndex = [];
      // }
      this.selectAllValue = true;
      this.mulitpledata = this.idsList;
      // this.idsList.forEach(element => {
      //   });
      this.Type = 1;
      var row1: any = this.grid.getSelectedRecords();
      this.ParentserialNumber = row1.filter(t => t.claimStatus != undefined && t.claimStatus != null && t.claimStatus != '').map(d => d.serialNo)
      this.LinkStatus = [];
      row1.forEach(element => {
        this.LinkStatus.push(element.claimStatus)
      });
      this.childTimeSheetId = [];
      this.ParentserialNumber.forEach(ele => {
        this.childData.filter(a => a.serialNo == ele).forEach(childdata => {
          this.childTimeSheetId.push(childdata.timeSheetId);
        });
      });
      var selectedrow = this.grid.getRowInfo(args.target)
      let resultantdata: any = selectedrow.rowData;
      row1.forEach(element => {
        if (element.claimStatus == 'Ready') {
          let serialNo = element.serialNo;
          this.TimesheetList.forEach(element => {
            if (element.serialNo == serialNo) {
            }
          });
        }
      });
      if (this.LinkStatus.some(isStatus => isStatus === "Validate")) {
        this.isCheckedBool = true;
      }
      else {
        this.isCheckedBool = false;
      }
      if (this.mulitpledata.length == 0) {
        this.selectAllValue = false;
      }
      for (var i = 0; i < args.selectedRowIndexes.length; i++) {
        var row = this.grid.getRowByIndex(args.selectedRowIndexes[i]);
        if (!row.querySelector('.disablecheckbox')) {
          customselect.push(args.selectedRowIndexes[i])
        }
      }
      this.grid.selectRows(customselect)
    }
    else {
      let rowfilter: any = this.grid.getSelectedRecords();
      this.LinkStatus = [];
      this.ParentserialNumber = rowfilter.filter(t => t.claimStatus != undefined && t.claimStatus != null && t.claimStatus != '').map(d => d.serialNo)
      rowfilter.forEach(element => {
        this.LinkStatus.push(element.claimStatus)
      });
      this.childTimeSheetId = [];
      this.ParentserialNumber.forEach(ele => {
        this.childData.filter(a => a.serialNo == ele).forEach(childdata => {
          this.childTimeSheetId.push(childdata.timeSheetId);
        });
      });
      if (this.LinkStatus.some(isStatus => isStatus === "Validate")) {
        this.isCheckedBool = true;
      }
      else {
        this.isCheckedBool = false;
      }
      this.selectAllValue = false;
      this.Type = 2;
      let result = this.grid.getRowInfo(args.target)
      this.result4 = result.rowData;
      if (args.checked) {
        this.selectsingleValue = true;
        this.singledata = this.TimesheetList.filter(findItem =>
          rowfilter.some(tlist => tlist.serialNo === findItem.serialNo && tlist.claimStatus != 'Validate')
        );    
      }
      else {
        this.singledata = this.TimesheetList.filter(findItem =>
          rowfilter.some(tlist => tlist.serialNo === findItem.serialNo)
        );
      }
    }
  }
  ///........................................rowDataBound....................................................
  rowDataBound(args) {
    // const claimStatus = 'claimStatus';
    this.idsList.forEach(element => {
      if (args.data['timesheetId'] == element) {
        this.selIndex.push(parseInt(args.row.getAttribute('aria-rowindex'), 10));
      }
    });

    if (args.data['bit'] > 0) {
      // args.row.style.background= 'red';
      // args.row.style.color= 'white';
      args.row.getElementsByClassName('e-gridchkbox')[0].classList.add('disablecheckbox');
      args.row.getElementsByClassName('e-checkbox-wrapper')[0].classList.add('disablecheckbox')
    }
  }
  ///........................................dataBound....................................................
  public dataBound(args): void {
    if (this.selIndex.length) {
      this.grid.selectRows(this.selIndex);
      this.selIndex = [];
    }
  }
  ///........................................showerrors....................................................
  showerrors(args) {

    this.isEnabled = false;
    this.showerrolist = [];
    this.showerrolistfilter = [];
    var grid = (parentsUntil(args.target, 'e-grid') as any);


    this.result3 = grid.ej2_instances[0].getRowInfo(args.target).rowData;
    this.startDateauth = this.result3.fromDate;
    this.endDateauth = this.result3.toDate;


    let serialno = this.result3.serialNo
    this.errorlist.forEach(element => {
      if (element.serialno == serialno) {

        this.showerrolist.push(element);
        JSON.parse(JSON.stringify(this.showerrolistfilter.push(element)));

      }
    });

    this.showerrolist.forEach(element => {
      this.clientauthId = element.clientauthId;
    });


    // this.dialogService.open(showerror);
  }
  ///........................................headerCellInfo....................................................
  headerCellInfo(args) {

    const toolcontent = args.cell.column.headerText;
    const tooltip: Tooltip = new Tooltip({
      content: toolcontent
    });
    tooltip.appendTo(args.node);

  }
  ///........................................tooltip....................................................
  tooltip(args: QueryCellInfoEventArgs) {
    if (args.column.field != null) {
      if (args.data[args.column.field] != null) {
        const tooltip: Tooltip = new Tooltip({
          content: args.data[args.column.field].toString()
        }, args.cell as HTMLTableCellElement);
      }
    }
  }
  ///........................................dataEmitFromCertificate....................................................
  dataEmitFromCertificate(event) {

    event.clientId = this.global.clientId;
    this.Editcert = event.isEdit;
     this.EditCertificateoption = event;
    this.ListSendBO.requesttype = "getdata"

    this.gettimesheetdata();

  }
  ///........................................EventfromSOCEdit....................................................
  EventfromSOCEdit(event: any) {
    this.EditSOC = event.isEdit;
    this.EditSOCOptions = event;
    this.ListSendBO.requesttype = "getdata"
    // document.getElementById("OpenModal1").click();
    document.getElementById("OpenModal2").click()
    this.gettimesheetdata();
  }
  ///........................................dataEmitpayfromChild....................................................
  // dataEmitpayfromChild(event: IsViewEditpayorequired) {
    dataEmitpayfromChild(event: any) {
    this.payoRequiredViewEdit.isEdit = false;
    this.payoRequiredViewEdit.isView = true;

    this.enablepayrate = false;
    document.getElementById("OpenModal1").click();
    document.getElementById("OpenModal2").click()
    this.ListSendBO.requesttype = "getdata"
    this.gettimesheetdata();
  }
  ///........................................closeerromodal....................................................
  closeerromodal() {
    document.getElementById('OpenModal1').click()
    this.ErrModalemployee.forEach(element => {
      element.columnName_i = "";
    });
    this.ErrModalCompany.forEach(element => {
      element.columnName_i = "";
    });
    this.ErrModalClient.forEach(element => {
      element.columnName_i = "";
    });

    this.ErrModalGrouppayor.forEach(element => {
      element.columnName_i = "";
    });
    this.ErrModalGrouppayorService.forEach(element => {
      element.columnName_i = "";
      element.grouplid = "";
      element.columnName_payor = "";
      element.columnName_service = "";
    });
    this.ErrModalIcd10.forEach(element => {
      element.columnName_i = "";
    });
    this.ErrModalclientAuth.forEach(element => {
      element.columnName_i = "";
    });
    this.ErrModalCompany = [];
    this.ErrModalClient = [];
    this.ErrModalGrouppayor = [];
    this.ErrModalGrouppayorService = [];
    this.ErrModalIcd10 = [];
    this.ErrModalclientAuth = [];
    this.ErrModalemployee = [];

  }
  ///........................................onResize....................................................
  onResize(args) {
    if (this.ColumnArray != null && this.ColumnArray != undefined) {
      const column = this.grid.getColumnByField(args.column.field)
      column.width = args.column.width;
      this.grid.refreshHeader();
      this.ColumnArray.forEach(element => {
        if (element.column == column.headerText) {
          element.width = parseInt(column.width.toString());
        }
      });
      // this.SaveColumnwidth();
    }
  }
  ///........................................getColumnwidth....................................................
  getColumnwidth() {
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    this.ColumnArray = this.arraycol[0].TimesheetVerification.Columns;
    this.grid.pageSettings.pageSize = this.arraycol[0].TimesheetVerification.Pagesize

    let hidecol = this.arraycol[0].TimesheetVerification.HideColumns;
    this.grid.hideColumns(hidecol);
    if (this.global.globalColumn.userid != null && this.global.globalColumn.agencyId != null) {
      this.id = this.global.globalColumn.id;
    }



    this.ColumnArray.forEach(element => {
      if (element.column == 'Client') {
        const column = this.grid.getColumnByField('clientName');
        column.headerText = element.column;
        column.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Payer') {
        const column1 = this.grid.getColumnByField('payorName');
        column1.headerText = element.column;
        column1.width = element.width;
      }
      if (element.column == 'Payor ID') {
        const column1 = this.grid.getColumnByField('billingpayorID');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Insured ID') {
        const column1 = this.grid.getColumnByField('client_InsuranceNo');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'From Date') {
        const column1 = this.grid.getColumnByField('fromDate');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'To Date') {
        const column1 = this.grid.getColumnByField('toDate');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Total Hours') {
        const column1 = this.grid.getColumnByField('totalHours');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      // if (element.column == 'Payable Hours') {
      //   const column1 = this.grid.getColumnByField('payableHours'); 
      //   column1.headerText = element.column;
      //   column1.width = element.width;
      //   this.grid.refreshHeader();
      // }
      if (element.column == 'Units') {
        const column1 = this.grid.getColumnByField('units');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }

      if (element.column == 'Net Charge') {
        const column1 = this.grid.getColumnByField('totalAmountExpected');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }

      if (element.column == 'Gross Charge') {
        const column1 = this.grid.getColumnByField('totalAmountBIlled');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }

      if (element.column == 'Employee') {
        const column1 = this.grid.getColumnByField('employee');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'UMPI') {
        const column1 = this.grid.getColumnByField('employee_UMPI');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }

      if (element.column == 'Claim Status') {
        const column1 = this.grid.getColumnByField('claimStatus');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Reason') {
        const column1 = this.grid.getColumnByUid('archieveNotes');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Service Code') {
        const column1 = this.grid.getColumnByField('serviceCode');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Error Notes') {
        const column1 = this.grid.getColumnByField('errorNotes');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Approve') {
        const column1 = this.grid.getColumnByField('isApproved');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Validate') {
        const column1 = this.grid.getColumnByField('validate');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == '') {
        const column1 = this.grid.getColumnByUid('checkbox');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }
      if (element.column == 'Paid Payroll') {
        const column1 = this.grid.getColumnByField('isPaid');
        column1.headerText = element.column;
        column1.width = element.width;
        this.grid.refreshHeader();
      }

      if (element.column == 'Action') {
        const column1 = this.grid.getColumnByUid('action');
        column1.headerText = 'Action';
        column1.width = element.width;
        this.grid.refreshHeader();
      }
    });
    if (this.TimesheetVerificationtab == "Active") {
      let columns = "Reason";
      this.grid.hideColumns(columns);

    }
    else if (this.TimesheetVerificationtab == "Archive") {
      let columns = "Reason";
      this.grid.showColumns(columns);
    }
    if (this.isclearFilteringorSorting == true) {
      this.grid.clearFiltering();
      this.grid.clearSorting();
    }
    this.isclearFilteringorSorting = false;
  }
  ///........................................SaveColumnwidth....................................................
  SaveColumnwidth() {
    this.arraycol[0].TimesheetVerification.Columns = this.ColumnArray;
    this.arraycol[0].TimesheetVerification.Pagesize = this.grid.pageSettings.pageSize;


    // this.columnchange.userid = parseInt(this.global.userID);
    // this.columnchange.column = JSON.stringify(this.arraycol);
    // this.columnchange.id = this.id;

    this.global.globalColumn = this.columnchange;
    this.arraycol = JSON.parse(this.global.globalColumn.column);
    let url = "api/ColumnChange/Savewidth?";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.columnchange, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.getColumnwidth();

    });
  }
  ///........................................valuechange....................................................
  valuechange() {
    //  debugger;
  }
  ///........................................exportAsExcel....................................................
  exportAsExcel(data) {
    this.downloadTimesheetVerificationExcel(data);

  }
  ///........................................downloadTimesheetVerificationExcel....................................................
  async downloadTimesheetVerificationExcel(data) {
    this.ListSendBO.verificationGuid = this.verificationGuid;
    let getBO = JSON.parse(JSON.stringify(this.ListSendBO));
    let url = data == "parentline" ? "api/TimeSheetVerfication/downloadTimesheetVerificationExcel" : "api/TimeSheetVerfication/ExportServiceline";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(getBO, url).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      const blob = this.b64toBlob(data.fileString, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = data.fileName;
      a.click();
    })
  }
  ///........................................b64toBlob....................................................
  b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  ///........................................updateClaim....................................................
  updateClaim() {
    this.sendToBillinProgress = true;
    if (this.Type == 1) {
      this.sendingdata = this.mulitpledata;
    }
    else if (this.Type == 2) {

      this.sendingdata = this.singledata;

    }
    this.sendingdata?.forEach(element => {


      element.fromDate = this.global.getDateTimeString(element.fromDate);
      element.toDate = this.global.getDateTimeString(element.toDate);
      element.billingLovLid = element.billingLovLid.toString();
    });
    if (this.sendingdata == null || this.sendingdata.length == 0) {
      this.toastrService.error('No Record Selected for update !!!');
      this.sendToBillinProgress = false;
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
    }
    else if (this.sendingdata.length != 0) {
      this.sendupdateclaimdata.timesheetVerifications = this.sendingdata;
      this.sendupdateclaimdata.claimMasterId = this.ListSendBO.Claimid;
      let url = "api/ClaimProcess/updateClaimDetails";
      this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.sendupdateclaimdata, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
        this.sendingdata = [];
        this.fromClaim.errorValidation = false;
        this.singledata = [];
        this.mulitpledata = [];
        this.ListSendBO.requesttype = "getdata";
        this.toastrService.success('Selected Record updated successfully!');
        this.sendToBillinProgress = false;
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
        this.outclaim.emit(this.sendupdateclaimdata.claimMasterId);
        return;
      }, (err: any) => {
        this.toastrService.error(err);
        this.sendToBillinProgress = false;
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);

      }
      );
    }
  }
  ///........................................getupdatetimesheet....................................................
  getupdatetimesheet(event, data) {
    let val = this.TimesheetList.filter(t => t.serialNo == data.serialNo)
    this.editEmployee = val[0].employee;
    this.editClient = val[0].clientName;
    this.editDate = data.serviceDate;
    this.edittime = data.dailyHours;
    this.editNotes = data.timesheetNotes;
    this.timesheetId = data.timeSheetId;
    this.editemployeeId = val[0].employeeId;
    this.editclientId = val[0].clientId;
    this.GridType = "child";
    this.clientId = val[0].clientId;
    this.childserviceDate = val[0].lineItem.filter(t => t.timeSheetId == this.timesheetId)[0].serviceDate;
    this.getAuthorizationDetails();
    this.editservice = data.serviceId.toString();
    this.checkchildclaimStatus = val[0].claimStatus;
    this.editgrouppayorId = val[0].lineItem.filter(t => t.timeSheetId == this.timesheetId)[0].groupPayorServiceId;
    this.clientAuthorizationId = val[0].lineItem.filter(t => t.timeSheetId == this.timesheetId)[0].authorizationId;
   
    this.getMappedEmployees();
    this.checkChildUpdateClaim();
   
  }
  ///........................................checkChildUpdateClaim....................................................
  checkChildUpdateClaim() {
    if (this.fromClaim.from == 'Claim') {
      if (this.checkchildclaimStatus != "Validate") {
        this.fromClaim.errorValidation = true;
      }
      else {
        this.fromClaim.errorValidation = false;
      }
    }
  }
  ///........................................timesheetwdates....................................................
  timesheetwdates(event, type) {
    if (type == "inputchage") {
      let val = this.dateservice.inputFeildchange(event);
      if (val != undefined) {
        let val1 = this.dateservice.inputFeildchange(event);
        this.editDate = val1;

      }
    }
    if (type == "datechagned") {
      let val = this.dateservice.Datechange(event);
      if (val != undefined) {
        let val1 = this.dateservice.Datechange(event);
        this.editDate = val1;
      }
    }

  }
  ///........................................numberonly....................................................
  numberonly(event: any, str) {
    this.ref.detach();
    setInterval(() => {
      this.ref.detectChanges();
    }, 10);
    if (((event.which < 48 && (event.which != 8 && event.which != 46 && event.which != 39 && event.which != 37)) || event.which > 57) && ((event.which < 96 && (event.which != 8 && event.which != 46 && event.which != 39 && event.which != 37)) || event.which > 105)) {
      event.preventDefault();
    }
    let txt = "";
    if (str == 'all') {
      txt = this.edithours;
    } else {
      txt = this.edittime
    }




    txt = (txt.trim) ? txt.trim() : txt.replace(/^\s+/, '');
    if (txt.length == 1) {
      if (txt == "2") {
        if (event.key > 3) {

          event.preventDefault();
        }

      }
      if (parseInt(txt) > 2) {
        if (event.which != 46) {
          event.preventDefault();
        }
      }
      if (txt == '.') {
        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {
          event.preventDefault();
        }
      }


    }

    if (txt.length == 2) {

      let tempdata = txt.split("");
      if (!(tempdata[1] == ".")) {
        if (tempdata[0] == ".") {

          if (tempdata[1] == "5" || tempdata[1] == "0") {

            if (!(event.which == 48)) {


              event.preventDefault();
            }
          }
          if (tempdata[1] == "2" || tempdata[1] == "7") {

            if (!(event.which == 53)) {


              event.preventDefault();
            }
          }
        }
        else if (event.which != 46) {
          event.preventDefault();
        }

      }
      else {

        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {
          event.preventDefault();
        }
      }


    }
    if (txt.length == 3) {

      let tempdata = txt.split("");

      if (tempdata[0] == ".") {
        event.preventDefault();
      }
      if (tempdata[2] == ".") {

        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {


          event.preventDefault();
        }

      }
      if (tempdata[1] == ".") {

        let tempdata1 = txt.split(".");

        if (tempdata1[1] == "5" || tempdata1[1] == "0") {

          if (!(event.which == 48)) {


            event.preventDefault();
          }
        }
        if (tempdata1[1] == "2" || tempdata1[1] == "7") {

          if (!(event.which == 53)) {


            event.preventDefault();
          }
        }
      }
    }
    if (txt.length == 4) {
      let tempdata = txt.split(".");

      if (tempdata[1].length == 2) {
        event.preventDefault();
      }

      if (tempdata[1] == "5" || tempdata[1] == "0") {

        if (!(event.which == 48)) {


          event.preventDefault();
        }
      }
      if (tempdata[1] == "2" || tempdata[1] == "7") {

        if (!(event.which == 53)) {


          event.preventDefault();
        }
      }
    }





    let val = txt.split('.');

    if (txt.length > 4) {
      event.preventDefault();
    }


  }
  ///........................................update....................................................
  update() {
    let temp: any = [];
    
    temp = {
      Id: this.timesheetId,
      TotalHours: parseFloat(this.edittime),
      EmployeeId: this.editemployeeId,
      ClientId: this.editclientId,
      MasterServiceId: parseInt(this.editservice),
      TimesheetDate: (this.editDate != null && this.editDate != undefined && this.editDate != '') ? this.global.getDateTimeString(this.editDate) : null,
      TimesheetNotes: this.editNotes,
      GroupPayorId: this.editgrouppayorId,
      authorizationId: parseInt(this.clientAuthorizationId)
    }
    let url = "api/Timesheet/updateTimesheet";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(temp, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success(
        'Timesheets updated successfully!'
      ), 8000;
      document.getElementById("update").click();
      this.checkBeforeApply()
    },
      (err: any) => {
        this.toastrService.error(
          err,
          "error",
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);

      })

  }
  ///........................................colseerr....................................................
  colseerr() {
    document.getElementById("OpenModal2").click();
  }
  ///........................................getClient....................................................
  getClient() {
    let url = "api/Client/GetClientListbyTd?"
    this.CommonAPI.GetFunctionwithResponseTypeJson("", url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ClientDropDown = data;
      this.ClientDropDown.forEach(element => {
        element.id = element.id.toString();
      })
    },
      (err: any) => {
        this.toastrService.error(
          err,
          "error",
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);

      })
  }
  ///........................................edittimesheet....................................................
  edittimesheet(data, args: any) {

    this.edithours = "";
    this.editserialnumber = data.serialNo;
    let val1 = this.TimesheetList?.filter(s => s.serialNo == data.serialNo);
    this.timesheetsToEdit = val1[0].lineItem.map(t => t.timeSheetId);
    this.editemp = parseInt(val1[0].lineItem[0].employeeId.toString());
    this.editcli = val1[0]?.clientId.toString();
    this.edithours = val1[0]?.lineItem[0]?.dailyHours.toString();
    this.checkParentclaimStatus = data.claimStatus;
    this.AuthorizationDetails=[]
    this.checkParentUpdateClaim();
    this.StartDate = data.fromDate;
    this.EndDate = data.toDate;
    this.GridType = "parent";
    this.getAuthorizationDetails();
    this.editserviceoverall = val1[0]?.lineItem[0]?.serviceId;
    this.editserviceoverall = this.editserviceoverall?.toString();
  }
  ///........................................checkParentUpdateClaim....................................................
  checkParentUpdateClaim() {
    if (this.fromClaim.from == 'Claim') {
      if (this.checkParentclaimStatus != "Validate") {
        this.fromClaim.errorValidation = true;
      }
      else {
        this.fromClaim.errorValidation = false;
      }
    }
    if(this.AuthorizationDetails.length>0 && this.editserviceoverall!=null && this.editserviceoverall!=undefined && this.editserviceoverall!='')
    {
      let authDetail=this.AuthorizationDetails?.filter(a=>a.masterserviceId==this.editserviceoverall)[0];
      if(authDetail!=null)
      {       
      this.clientAuthorizationId=authDetail?.id;
      }
    }
    else 
    {
      this.clientAuthorizationId=null;
    }
    this.AuthorizationDetails?.forEach(element => {
      if (element.id == this.clientAuthorizationId) {
        element.isAuthBoolean = true;
      }
      else {
        element.isAuthBoolean = false;
      }
    });

  }
  ///........................................editTotaltimesheet....................................................
  editTotaltimesheet() {
    let value = {
      serialnumber: this.editserialnumber,
      employee: parseInt(this.editemp),
      client: parseInt(this.editcli),
      clientAuthorizationId: parseInt(this.clientAuthorizationId),
      masterServiceId: parseInt(this.editserviceoverall),
      timesheetIds: this.timesheetsToEdit,
      start: this.global.getDateTimeString(this.StartDate),
      end: this.global.getDateTimeString(this.EndDate),
    }
    let url = "api/Timesheet/BulkupdateofTimesheet"
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(value, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      document.getElementById("editall").click();
      this.checkBeforeApply();
      let status: any = "success";
      this.toastrService.success(
        'Timesheet updated successfully!'
      ), 8000;

    },
      (err: any) => {
        this.toastrService.error(
          err,
          "error",
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);

      })
  }
  ///........................................closeTimesheet....................................................
  closeTimesheet() {
    this.fromClaim.errorValidation = false;
    document.getElementById("editall").click();
  }
  ///........................................closeTimes....................................................
  closeTimes() {
    this.fromClaim.errorValidation = false;
    document.getElementById("editall").click();
  }
  ///........................................CloseChildGridModal....................................................
  CloseChildGridModal() {
    this.fromClaim.errorValidation = false;
    document.getElementById("update").click();
  }
  ///........................................SplitdayModalClose....................................................
  SplitdayModalClose() {
    document.getElementById("OpenModal3").click();

  }
  ///........................................tabchanged....................................................
  tabchanged(isValue) {
    this.TimesheetVerificationtab = isValue;
    this.gettimesheetdata();
    this.ParentserialNumber = [];
    this.LinkStatus = [];
    this.childTimeSheetId = [];
  }
  ///........................................getMappedEmployees....................................................
  TimeSheetVerificationArchive() {
    this.disabledNotes = true;
    let payload =
    {
      timesheetIds: this.childTimeSheetId,
      note: this.Archievenotes
    }
    let url = "api/TimeSheetVerfication/moveToArchive";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(payload, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
      this.gettimesheetdata();
      this.Archievenotes = null;
      this.disabledNotes = false;
      document.getElementById("openArchiveNotes").click()
      this.childTimeSheetId = [];
      this.ParentserialNumber = [];
      this.LinkStatus = [];
      this.mulitpledata = [];
      this.sendingdata = [];
      this.toastrService.success('TimeSheet Verification archived successfully!');
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
    },
      (err: any) => {
        this.disabledNotes = false;
        this.toastrService.error(err, 'error');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      })
  }
  ///........................................getMappedEmployees....................................................
  TimeSheetVerificationActive() {
    let url = "api/TimeSheetVerfication/moveToActive";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.childTimeSheetId, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: number) => {
      this.gettimesheetdata();
      this.childTimeSheetId = [];
      this.ParentserialNumber = [];
      this.LinkStatus = [];
      this.mulitpledata = [];
      this.sendingdata = [];
      this.toastrService.success('TimeSheet Verification restored to active successfully!');
      setTimeout(() => {
        this.toastrService.clear();
      }, 8000);
    },
      (err: any) => {
        this.toastrService.error(err, 'error');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      })
  }
  ///........................................getMappedEmployees....................................................
  getMappedEmployees() {
    let params = new URLSearchParams();
    params.append("ClientId", this.editclientId);
    let url = "api/ClientEmployeeRelationship/GetActiveMappedEmployees?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.employees = data;
    },
      (err: any) => {
        this.toastrService.error(err, 'error');
        setTimeout(() => {
          this.toastrService.clear();
        }, 8000);
      })
  }
  ///........................................shownotesdescription....................................................
  shownotesdescription(reason) {
    this.Reasonforarchive = reason;
  }
  ///........................................closeReason....................................................
  closeReason() {
    document.getElementById("openArchiveNotes").click();
    this.Archievenotes = null;

  }
  ///........................................closeNotesReason....................................................
  closeNotesReason() {
    document.getElementById("OpenNotesReasonModal").click();


  }
  ///........................................getAllClient....................................................
  getAllClient() {
    let param = new URLSearchParams();

    let locId;
    if (this.global.globalLocationId != null && this.global.globalLocationId != ''
      && this.global.globalLocationId != undefined) {
      locId = parseInt(this.global.globalLocationId);
    }
    else {
      locId = "00000000-0000-0000-0000-000000000000";
    }
    param.append("LocationId", locId);
    let url = "api/Client/GetAllClientsDropDownbyAgency?"
    this.CommonAPI.GetFunctionwithResponseTypeJson(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any[]) => {
      this.AllClientDropDownListwithStatus = JSON.parse(JSON.stringify(data));
      this.AllClientDropDownListwithStatus.forEach(record => {
          record.Key = record.id.toString();
          record.Value = record.names + " (" + record.status + ")";
          
          if (record.medicaid) {
            record.Value += " (" + record.medicaid + ")";
          }
        });     
                
    })
  }
  ///........................................getAllEmployeeDropDown....................................................
  getAllEmployeeDropDown() {
    let url = "api/Employee/GetTimesheetEmployeesDropDownbyAgency?";
    let params = new URLSearchParams();
    params.append("LocationId", this.locationLid);
    this.CommonAPI.GetFunctionwithResponseTypeJson(this.locationLid, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.AllEmployeeDropDownListwithStatus = JSON.parse(JSON.stringify(data));
      this.AllEmployeeDropDownListwithStatus.forEach((employeeRecords) => {
        employeeRecords.Key = employeeRecords.id.toString();
        employeeRecords.Value =
          employeeRecords.names +
          " (" +
          employeeRecords.status + ")"
      });
      this.EmployeeDropDown = data.filter(e => e.status == "ACTIVE");
    });
  }
  ///........................................FunctionPermission....................................................
  FunctionPermission() {
    let params = new URLSearchParams();
    params.append("pagecode", "TimesheetVerification");
    //params.append("roleId", this.global.roleId);
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data != null) {
        this.fp = data;
      }
      else {
        this.fp = new fp();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new fp();
      })
  }
  getAuthorizationDetails() {
    let startDate = "";
    let endDate = "";
  
    if (this.GridType == "child") {
      startDate = this.editDate;
      endDate = this.editDate;
    }
    else {
      startDate = this.StartDate;
      endDate = this.EndDate;
      this.clientId = (this.editcli == null || this.editcli == undefined || this.editcli == '') ? 0 : this.editcli;
    }
    this.editservice=null;
    this.clientAuthorizationId=null;
    this.editserviceoverall=null;
    let parameter = new URLSearchParams();
    parameter.append("startdate", this.global.getDateTimeString(startDate))
    parameter.append("enddate", this.global.getDateTimeString(endDate))
    parameter.append("clientid", parseInt(this.clientId).toString())
    let url = "api/Timesheet/FilteracctoStartdate?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(parameter, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      let i;
      this.serviceName = "";
      let service = [];
      data?.forEach(element => {
        if (element.remaingHours <= 100) {
          element.isColorEditValue = true;
        }
        else {
          element.isColorEditValue = false;
        }
      });
      if (data.length != 0) {
        for (i = 0; i < data.length; i++) {
          data[i].Value=data[i].masterServiceCode +","+ data[i].serviceDesc;
          data[i].Key = data[i].masterserviceId.toString();
          service[i] = { value: data[i].masterServiceCode, label: data[i].masterServiceCode, key: data[i].masterServiceId };
          let hrMinStr = data[i].hoursPerDay.toString().split('.');
          if (hrMinStr.length == 1) {
            data[i].hoursPerDay = hrMinStr[0] + " hr " + "0 Min";
          }
          else {
            let minStr = 0 + "." + hrMinStr[hrMinStr.length - 1];
            data[i].hoursPerDay = hrMinStr[0] + " hr " + (parseFloat(minStr) * 60).toString().split('.')[0] + "Min";
          }
          let hoursPerDayBasedOnLastVisitDateString = data[i].hoursPerDayBasedOnLastVisitDate?.toString().split('.');
          if (hoursPerDayBasedOnLastVisitDateString.length == 1) {
            data[i].hoursPerDayBasedOnLastVisitDate = hoursPerDayBasedOnLastVisitDateString[0] + " hr " + "0 Min";
          }
          else {
            let minStr = 0 + "." + hoursPerDayBasedOnLastVisitDateString[hoursPerDayBasedOnLastVisitDateString.length - 1];
            data[i].hoursPerDayBasedOnLastVisitDate = hoursPerDayBasedOnLastVisitDateString[0] + " hr " + (parseFloat(minStr) * 60).toString().split('.')[0] + "Min";
          }
          if (data[i].remaingHours <= 100) {
            this.isColorEditValue[i] = true;
          }
          else {
            this.isColorEditValue[i] = false;
          }
          let hrMinStr1 = data[i].remaingHours.toString().split('.');
          if (hrMinStr1.length == 1) {
            data[i].remaingHours = hrMinStr1[0] + " hr " + "0 Min";
          }
          else {
            let minStr1 = 0 + "." + hrMinStr1[hrMinStr1.length - 1];
            data[i].remaingHours = hrMinStr1[0] + " hr " + (parseFloat(minStr1) * 60).toString().split('.')[0] + "Min";
          }
          let hrperWeekMinStr = data[i].hoursPerWeek.toString().split('.');
          if (hrperWeekMinStr.length == 1) {
            data[i].hoursPerWeek = hrperWeekMinStr[0] + " hr " + "0 Min";
          }
          else {
            let minStr = 0 + "." + hrperWeekMinStr[hrperWeekMinStr.length - 1];
            data[i].hoursPerWeek = hrperWeekMinStr[0] + " hr " + (parseFloat(minStr) * 60).toString().split('.')[0] + "Min";
          }
        }
      }
      this.AuthorizationDetails = data;
      if(this.AuthorizationDetails.length>0)
      {
        let authDetail=this.AuthorizationDetails?.filter(a=>a.masterserviceId==this.editserviceoverall)[0];
        if(authDetail!=null)
        {       
        this.clientAuthorizationId=authDetail?.id;
        
        }
      }
      this.AuthorizationDetails?.forEach(element => {
        if (element.id == this.clientAuthorizationId) {
          element.isAuthBoolean = true;
        }
        else {
          element.isAuthBoolean = false;
        }
      });
      let servicetype:any=this.editservice;
      if (servicetype!= null) {
        this.editservice= parseInt(servicetype).toString();
      }
    })
  }
  selectSpecifyService(specifyAuthorizationdetails) {
    this.clientAuthorizationId = specifyAuthorizationdetails.id;
    this.AuthorizationDetails?.forEach(element => {
      if (element.id == this.clientAuthorizationId) {
        element.isAuthBoolean = true;
      }
      else {
        element.isAuthBoolean = false;
      }
    });
    this.editservice= specifyAuthorizationdetails.masterserviceId.toString();

    this.editserviceoverall=specifyAuthorizationdetails.masterserviceId.toString();
  }

  getClientAuth()
  {
    if(this.editservice!=null && this.editservice!=undefined && this.editservice!=0)
    {
    let clientAuthDetails = this.AuthorizationDetails?.filter(a => a.masterserviceId == this.editservice)[0];
   
    this.clientAuthorizationId = clientAuthDetails.id;
    }
    else 
    {
      this.clientAuthorizationId=null;
    }
    this.AuthorizationDetails?.forEach(element => {
      if (element.id == this.clientAuthorizationId) {
        element.isAuthBoolean = true;
      }
      else {
        element.isAuthBoolean = false;
      }
    });
  }
  
    //.................................................AddClientAuthorization........................................................
    AddClientAuthorization() {
      this.authinput.ClientId = this.clientId.toString();
      this.authinput.isEdit = true;
      this.authinput.type = "new";
      this.authinput.isEditAuthorization = true;
      this.authinput.isView = false;
      this.EditAuthorization = true;
    }
   
  closeSupervisingMapModel(){
    this.editSupervisingprovider=false;
    document.getElementById("Supervisingopen").click();
    document.getElementById("OpenModal1").click();
    document.getElementById("OpenModal2").click();    
    this.gettimesheetdata();
  }
    clearGridLocalStorage(): void {
    // Define grid configurations for visits
    const gridConfigs = [
      { localStorageKey: 'gridTimesheetVerificationGrid', expectedColumns: this.TimesheetVerificationTotalColumns },
    ];
    
    // Use global method for localStorage clearing
    this.global.clearGridIdLocalStorage(gridConfigs);
  }
  ///........................................ngOnDestroy....................................................
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}


